import { ref, computed, ComputedRef } from 'vue'
import type { Ref } from 'vue'
import { MessageChat, Reply } from '@/types/message'
import StoreMessage, { getMessage } from '@/store/messages'

const isMessage = ref<string>('')
const sendMessage = ref<boolean>(false)

interface UseMessage {
  isMessage: Ref<string>
  sendMessage: Ref<boolean>
  StoreMessage: MessageChat[]
  isSelectMessageReply: ComputedRef<Reply | null>
  getIsMessage: () => string
  setIsMessage: (value: string) => void
  clearIsMessage: () => void
  defineBackgroundColor: (value: string) => string
}

export default function useMessage (): UseMessage {
  const isSelectMessageReply = computed<Reply | null>(() => {
    const message = getMessage(isMessage.value)
    if (!message) return null

    return {
      message_id: message.uuid,
      type: message.type,
      content: {
        message: message.content.message,
        type: message.content.type
      }
    }
  })

  function getIsMessage (): string {
    return isMessage.value
  }

  function setIsMessage (payload: string): void {
    isMessage.value = payload
  }

  function clearIsMessage (): void {
    isMessage.value = ''
  }

  function defineBackgroundColor (type: string): string {
    if (type === 'sent') return 'bg-gray-200'

    return 'bg-gray-100'
  }

  return {
    StoreMessage,
    sendMessage,
    isMessage,
    isSelectMessageReply,
    getIsMessage,
    setIsMessage,
    clearIsMessage,
    defineBackgroundColor
  }
}
